import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import { IGetLaundriesRes } from "types/laundry"

import laundriesService from "api/laundriesService"
import { IGetLaundriesQueryParams } from "types/laundry"

interface IGetLaundriesParams {
  query: IGetLaundriesQueryParams
  enabled: boolean
}

const useGetLaundries = ({ query, enabled  }: IGetLaundriesParams) => {
  return useQuery("laundries", async () => {
    try {
      const res: AxiosResponse<IGetLaundriesRes> = await laundriesService.getLaundries(query)

      return res.data
    }  catch (err: any) {
      return err.response
    }
  }, { enabled, refetchOnMount: false, refetchOnWindowFocus: false })
}

export default useGetLaundries